import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import { SimpleSelect1 } from "../SimpleSelect/SimpleSelect1";
import { TagSelection } from "../../data/crmGeneralData";
import { useChangeOfflineInvoiceTag, useShowTag } from "../../hooks/useCrm";
const initvalue = {
  IdOrderOffline: null,
  FactorTag: "",
};
export const TagSelectionOfflineInvoiceModal = ({
  show,
  handleClose,
  factorId,
  factorTag,
}) => {
  const [button] = useState(false);
  const [form, setForm] = useState(initvalue);
  const { data: Tags } = useShowTag();
  useEffect(() => {
    setForm({ ...form, IdOrderOffline: factorId });
  }, [factorId]);

  const { mutateAsync: ChangeTag } = useChangeOfflineInvoiceTag();
  const tagsOptions = Tags?.data?.tags?.map((tag) => {
    return {
      value: tag.NameTag,
      label: tag.NameTag,
    };
  });
  const handleChangeTag = async (data) => {
    await ChangeTag(data).then(() => setForm({ ...form, FactorTag: "" }));
  };
  return (
    <BootstrapModal
      modaltitle="انتخاب برچسب"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12">
          <SimpleSelect1
            label="انتخاب برچسب"
            res={tagsOptions}
            onChange={(e) => setForm({ ...form, FactorTag: e.value })}
            placeholder={factorTag}
          />
        </div>
        <div className="col-12">
          <Button
            bgColor="#009ef7"
            color="#fff"
            onclick={() => {
              handleChangeTag(form);
              handleClose();
            }}
          >
            تایید
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
